<template>
    <el-form :model="smsForm" :rules="smsRules" ref="smsElForm" class="m-login-smsForm">
        <el-form-item class="form-item" prop="mobile">
            <i class="nucfont inuc-mobile"></i>
            <el-input type="text" v-model="smsForm.mobile" :placeholder="$t('tip.mobile')"></el-input>
        </el-form-item>

        <el-form-item class="form-item" prop="checkCode">
            <el-col :span="14">
                <i class="nucfont inuc-feedback"></i>
                <el-input v-model="smsForm.checkCode" :placeholder="$t('tip.code')"></el-input>
            </el-col>
            <el-col :span="9" :offset="1">
                <el-button
                    @click="sendCode(smsForm.mobile)"
                    class="btn-send"
                    :disabled="!isMobileValid || codeStatus===1">{{codeText}}
                </el-button>
            </el-col>
        </el-form-item>
    </el-form>
</template>

<script>
    import {Exp} from '@/config/constant'

    const config = require("@/config")

    export default {
        data() {
            return {
                smsForm: {
                    mobile: '',
                    checkCode: '',
                },
                smsRules: {
                    mobile: [
                        {required: true, message: this.$t('tip.mobile'), trigger: 'blur'},
                        {pattern: Exp.mobile, message: this.$t('app.errorMobile'), trigger: 'blur'},
                        {validator: this.mobileOccupation, trigger: "blur"}
                    ],
                    checkCode: [
                        {required: true, message: this.$t('tip.code'), trigger: 'blur'},
                    ]
                },
                isMobileValid: false,
                codeStatus: 0,  // 0: 未发送 1：已发送 2：重新获取
                codeTimer: 0,   // 倒计时
            }
        },

        computed: {
            codeText() {
                return [this.$t('app.getCode'), this.$t('app.waitCode', [this.codeTimer]), this.$t('app.getCodeAgain')][this.codeStatus]
            },
        },

        methods: {
            mobileOccupation(rule, value, callback) {
                this.$api.mobileOccupation({mobile: value}).then(res => {
                    let exist = res.package
                    if (exist) {
                        this.isMobileValid = true
                        callback()
                    } else {
                        this.isMobileValid = false
                        callback(new Error(this.$t('app.unbound')))
                    }
                })
            },

            sendCode(mobile) {
                let isValid = true
                this.$refs['smsElForm'].validateField('smsElForm', errMsg => {
                    if (errMsg) isValid = false
                })
                if (!isValid) return

                if (!(this.codeStatus === 0 || this.codeStatus === 2)) return

                this.$api.smsapiSend({mobile}).then(res => {
                    this.codeTimer = 60
                    this.codeStatus = 1

                    this.$message.success(this.$t('m.checkCode'))

                    clearInterval(window.timeHandler)
                    window.timeHandler = setInterval(() => {
                        this.codeTimer--

                        if (this.codeTimer <= 0) {
                            clearInterval(window.timeHandler)
                            this.codeStatus = 2
                        }
                    }, 1000)
                }).catch(error => {
                    console.log(error)
                    this.codeStatus = 0
                })
            },

            login() {
                let data = {
                    ...this.smsForm,
                    version: config.version
                }

                return new Promise((resolve, reject) => {
                    this.$refs['smsElForm'].validate(valid => {
                        if (!valid) {
                            reject('表单验证未通过')
                            return
                        }

                        resolve(this.$api.smsLogin(data))
                    })
                })
            }
        },
    }
</script>
<style lang="scss">
    @import '~@/style/const';

    .m-login-smsForm {
        .btn-send {
            padding: 12px 0;
            width: 100%;
        }
    }

    .app-root:not(.lang-zh-CN) {
        .m-login-smsForm {
            .btn-send {
                font-size: 12px;
                @include no-wrap
            }
        }
    }
</style>
